
import FButton from '@/components/atoms/buttons/h-button';
import FIcon from '@/components/atoms/icons/h-icon';
import FInfoTooltip from '@/components/molecules/tooltips/info-tooltip';
import LoginModalHandling from '@/mixins/login-modal-handling';

export default {
  name: 'RecommendationCard',

  components: { FButton, FIcon, FInfoTooltip },

  mixins: [LoginModalHandling],

  props: {
    buttonDisabled: {
      type: Boolean,
    },
    bottomItems: {
      type: Array,
      required: true,
    },
    ctaButtonLink: {
      type: Object,
      required: true,
    },
    ctaButtonTitle: {
      type: String,
      required: true,
    },
    ctaText: {
      type: String,
      required: true,
    },
    extraItems: {
      type: Array,
      required: true,
    },
    extraToggleTitle: {
      type: String,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
    },
    selectedTitle: {
      type: String,
      default: '',
    },
    selectedIcon: {
      type: String,
      default: '',
    },
    topItems: {
      type: Array,
      required: true,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    noFollow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isExtraOpen: false,
    };
  },

  methods: {
    async handleButtonCLick() {
      await this.$emit('button-click');

      if (this.ctaButtonLink.name === 'propSearchLogin') {
        this.openLoginModal('prop_search');
      } else {
        setTimeout(() => {
          window.location.href = this.ctaButtonLink.href;
        }, 1000);
      }
    },
  },
};
